import { BehaviorSubject, Subject, from } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import getTermManualService from "../services/downloadTermManual";
import { downloadFile } from "../utils/downloadFile";
export var downloadTermManualAction$ = new Subject();
var downloadTermManualPayloadStore$ = new BehaviorSubject({
    termKey: ""
});
export var downloadTermManualStore$ = new BehaviorSubject({});
downloadTermManualAction$.subscribe(downloadTermManualPayloadStore$);
downloadTermManualAction$.pipe(switchMap(function(param) {
    var termKey = param.termKey;
    return getTermManualService({
        termKey: termKey
    }).pipe(map(function(param) {
        var fileAccessInformation = param.fileAccessInformation;
        fileAccessInformation.forEach(function(fileInformation) {
            var _fileInformation;
            downloadFile((_fileInformation = fileInformation) === null || _fileInformation === void 0 ? void 0 : _fileInformation.s3presignedUrl);
        });
        return {
            response: fileAccessInformation
        };
    }), catchError(function(err) {
        return from([
            {
                error: err
            }
        ]);
    }));
})).subscribe(downloadTermManualStore$);
downloadTermManualStore$.subscribe(function(param) {
    var error = param.error;
    if (!error) {
        // eslint-disable-next-line no-useless-return
        return;
    }
// TODO: implement notification for failed request
});

//# sourceMappingURL=downloadTermManualStore.js.map